import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';
import Topmenuright from '../Components/Topmenuright';
import { useNavigate } from 'react-router-dom';

function ResultsTable() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchResults();
    // eslint-disable-next-line
  }, [page, search]);

  const fetchResults = async () => {
    setLoading(true);
    setError('');
    try {
      const url = `https://sbsedelhi.com/backend/wp-json/custom/v1/mytable?page=${page}&per_page=${perPage}` + (search ? `&regno=${encodeURIComponent(search)}` : '');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch results');
      const data = await response.json();
      setResults(Array.isArray(data.results) ? data.results : data);
      setTotal(data.total || data.length || 0);
    } catch (err) {
      setError('Failed to fetch results.');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (regno) => {
    navigate(`/AddResult?id=${encodeURIComponent(regno)}`);
  };

  const handleDelete = async (regno) => {
  if (!window.confirm(`Are you sure you want to delete enrollment no: ${regno}?`)) return;

    try {
      setLoading(true);
      const url = `https://sbsedelhi.com/backend/wp-json/custom/v1/mytable/${encodeURIComponent(regno)}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });
      
      if (!response.ok) throw new Error('Failed to delete result');

      // Remove deleted item from frontend
      setResults(results.filter(item => item.regno !== regno));
      setTotal(total - 1);
    } catch (err) {
      setError('Failed to delete result.');
    } finally {
      setLoading(false);
    }
  };


  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const totalPages = Math.ceil(total / perPage);

  return (
    <div>
      <Helmet>
        <title>All Student Results</title>
      </Helmet>
      <Header />

      <div className='inner-main-navigation container'>      
          <Topmenuright />
      </div>

      <div className="container main-contant">
        <div className="inner-page-container">
          <h1 className="page-title" style={{ textAlign: 'center', fontWeight: 700, marginBottom: 32, fontSize: 32, color: '#007bff' }}>All Student Results</h1>
          {loading && <div style={{ textAlign: 'center', fontSize: 18, color: '#007bff', marginBottom: 16 }}>Loading...</div>}
          {error && <div style={{ color: 'red', textAlign: 'center', fontSize: 16, marginBottom: 16 }}>{error}</div>}
          <div style={{ margin: '24px 0', display: 'flex', justifyContent: 'center' }}>
            <input
              type="text"
              placeholder="Search by Enrollment No..."
              value={search}
              onChange={handleSearchChange}
              style={{ padding: '12px 16px', width: 320, borderRadius: 8, border: '1px solid #ccc', fontSize: 18 }}
            />
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 16, background: '#fff', borderRadius: 8, boxShadow: '0 1px 8px #ececec' }}>
              <thead>
                <tr style={{ background: '#2a5db0', color: '#fff' }}>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Enrollment No</th>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Student's Name</th>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Father's Name</th>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Year</th>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Division</th>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Grade</th>
                  <th style={{ border: '1px solid #e0e0e0', padding: 12 }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {results.length > 0 ? results.map((item, idx) => (
                  <tr key={idx} style={{ background: idx % 2 === 0 ? '#f7f9fc' : '#fff' }}>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10 }}>{item.regno}</td>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10 }}>{item.name}</td>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10 }}>{item.fname}</td>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10 }}>{item.pyear || item.year_of_passing}</td>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10 }}>{item.division}</td>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10 }}>{item.grade}</td>
                    <td style={{ border: '1px solid #e0e0e0', padding: 10, textAlign: 'center' }}>
                      <button onClick={() => handleEdit(item.regno)} style={{ background: '#007bff', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px', fontSize: 15, fontWeight: 500, cursor: 'pointer' }}>Edit</button>
                       <button
    onClick={() => handleDelete(item.regno)}
    style={{ background: '#dc3545', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px',  marginLeft: '8px', fontSize: 15, fontWeight: 500, cursor: 'pointer' }}
  >
    Delete
  </button>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, fontSize: 18, color: '#888' }}>No data found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 32, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16 }}>
            <button onClick={() => setPage(page - 1)} disabled={page === 1} style={{ padding: '10px 24px', background: '#007bff', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, fontWeight: 500, cursor: page === 1 ? 'not-allowed' : 'pointer' }}>Prev</button>
            <span style={{ fontSize: 18, fontWeight: 500 }}>Page {page} of {totalPages || 1}</span>
            <button onClick={() => setPage(page + 1)} disabled={page === totalPages || totalPages === 0} style={{ padding: '10px 24px', background: '#007bff', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, fontWeight: 500, cursor: (page === totalPages || totalPages === 0) ? 'not-allowed' : 'pointer' }}>Next</button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ResultsTable;
